export default {"src":"/_next/static/media/menu.9b6d444b.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};